export function pdpStatus(course, titles) {
	const { status } = course;
	const titleObj = titles.find((title) => title.id === course.course_id);
	const course_type = titleObj ? titleObj.course_type : 'xxx';
	const { supervisor_comment, superior_comment, requested_by } = course;
	let userIcon, superiorIcon, supervisorIcon, statusText;

	switch (requested_by) {
		case 'user':
			switch (status) {
				case 'superior_pending':
					userIcon = course_type === '2' ? 'success-dark' : 'success';
					superiorIcon = course_type === '2' ? 'success-dark' : 'waiting';
					supervisorIcon = course_type === '2' ? 'success-dark' : 'waiting';
					statusText = course_type === '2' ? 'الزامی توسط سازمان' : 'در انتظار اعمال نظر توسط مافوق و سازمان';
					break;
				case 'supervisor_pending':
					userIcon = course_type === '2' ? 'success-dark' : 'success';
					superiorIcon =
						course_type === '2' ? 'success-dark' : superior_comment && superior_comment.length === 0 ? 'dislike' : 'like';
					supervisorIcon = course_type === '2' ? 'success-dark' : 'waiting';
					statusText =
						course_type === '2'
							? 'الزامی توسط سازمان'
							: `${
									superior_comment && superior_comment.length === 0 ? '' : 'تایید توسط مافوق'
							  } در انتظار اعمال نظر توسط سازمان`;
					break;
				case 'rejected_by_superior':
					userIcon = course_type === '2' ? 'success-dark' : 'success';
					superiorIcon = course_type === '2' ? 'success-dark' : 'dislike';
					supervisorIcon = course_type === '2' ? 'success-dark' : 'waiting';
					statusText = course_type === '2' ? 'الزامی توسط سازمان' : 'رد شده توسط مافوق در انتظار اعمال نظر توسط سازمان';
					break;
				case 'rejected_by_supervisor':
					userIcon = course_type === '2' ? 'success-dark' : 'success';
					superiorIcon =
						course_type === '2'
							? 'success-dark'
							: superior_comment === null || superior_comment.length === 0
							? 'like'
							: 'dislike';
					supervisorIcon = course_type === '2' ? 'success-dark' : 'dislike';
					statusText = course_type === '2' ? 'الزامی توسط سازمان' : 'رد توسط سازمان';
					break;
				case 'active':
					userIcon = course_type === '2' ? 'success-dark' : 'success';
					superiorIcon =
						course_type === '2'
							? 'success-dark'
							: superior_comment === null || superior_comment.length === 0
							? 'like'
							: 'dislike';
					supervisorIcon = course_type === '2' ? 'success-dark' : 'like';
					statusText = course_type === '2' ? 'الزامی توسط سازمان' : 'موافقت نهایی';
					break;
				default:
					return {
						userIcon: null,
						superiorIcon: null,
						supervisorIcon: null,
						statusText: null,
					};
			}
			break;
		case 'superior':
			switch (status) {
				case 'supervisor_pending':
					userIcon = 'empty';
					superiorIcon = 'success';
					supervisorIcon = 'waiting';
					statusText = 'انتخاب شده توسط مافوق و در انتظار اعمال نظر توسط سازمان';
					break;
				case 'rejected_by_supervisor':
					userIcon = 'empty';
					superiorIcon = 'success';
					supervisorIcon = 'dislike';
					statusText = 'درخواست توسط مافوق و رد توسط سازمان';
					break;
				case 'active':
					userIcon = 'empty';
					superiorIcon = 'success';
					supervisorIcon = 'like';
					statusText = 'درخواست توسط مافوق و تایید توسط سازمان';
					break;
				default:
					return {
						userIcon: null,
						superiorIcon: null,
						supervisorIcon: null,
						statusText: null,
					};
			}
			break;
		case 'supervisor':
			if (status === 'active') {
				userIcon = 'empty';
				superiorIcon = 'empty';
				supervisorIcon = 'success';
				statusText = 'انتخاب شده توسط سازمان';
			}
			break;
		default:
			return {
				userIcon: null,
				superiorIcon: null,
				supervisorIcon: null,
				statusText: null,
			};
	}

	return {
		userIcon,
		superiorIcon,
		supervisorIcon,
		statusText,
	};
}
